<template>
	<div class="pay">
		<header>
			<h1>
				<router-link to="/discover/all">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">订单支付</p>
			</h1>
		</header>
		<div class="pay_xx" v-for="item in book_li">
			<p class="yxx_a">订单信息</p>
			<p class="yxx_b">购买专辑：<span>{{item.b_bookname}}{{item.chapter}}</span></p>
			<p class="yxx_c">订单金额：<span>￥{{item.b_price}}</span></p>
			<p class="yxx_d">实付金额：<span>￥{{item.b_price}}</span></p>
			
		</div>
        <div class="tc_nav">
            <span class="tc_navx"></span>
        </div>
		<button class="yxx_but" v-on:click="add()">提交订单</button>
	</div>
</template>
<script type="text/javascript">
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
	export default {
	 data(){
          return {
              params: '',
              book_li:[],
              pay:[],
              zpay:[],
          }
      },
      created(){
		  var param = this.$route.params.id;
          this.params = param;
          this.zpay = this.params.split(',')//
          var openid=localStorage.getItem("openid");
          this.openid = openid;
          this.pay=[this.$route.params.id];
          /*
          点击提交订单，访问后台接口
          地址：CURL+'/user/wxpay/pay
          参数：openid,专辑id，订单金额
          回调成功后会返回一个json数据，然后把数据转给 callpay()
           */
          //console.log(openid)
      },
       methods:{
            getAjax:function () {
             var successCallback =  (response) => {
                console.log('服务器请求成功了')
                if(response){
                  this.book_li = response.booklist
                  this.pay[2] = response.booklist[0].b_price
                  for(var i=0;i<response.bookpartlist.length;i++){
                    if(this.zpay[1] == response.bookpartlist[i].bp_id){
                      this.book_li[0]['chapter'] = response.bookpartlist[i].bp_title
                      this.book_li[0]['b_price'] = response.bookpartlist[i].bp_price
                    }
                  }
                  
                }
              }
              var errorCallback =  (response) => {
                  console.log('服务器请求出错了')
              }
               if(this.zpay[3]!=1){

                      this.$http.get(CURL+'/portal/All/getpay?id='+this.$route.params.id,{
                      data:{}
                    }).then(successCallback,errorCallback);
                  }else{
                      this.$http.get(CURL+'/portal/All/getpay?id='+this.zpay[0],{
                      data:{}
                    }).then(successCallback,errorCallback);
                  }
              // 向后台传id 根据id接收数据
              
            },
            callpay:function(params){

                if (typeof WeixinJSBridge == "undefined"){
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(params), false);
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(params)); 
                        document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(params));
                    }
                }else{
                     this.jsApiCall(params);
                }
            },
              jsApiCall:function (params){ 
              // console.log(params)   
                WeixinJSBridge.invoke(
                      'getBrandWCPayRequest',{
                      'appId': params.appId, // 公众号名称，由商户传入
                      'timeStamp': params.timeStamp, // 时间戳，自1970年以来的秒数
                      'nonceStr': params.nonceStr, // 随机串
                      'package': params.package,
                      'signType': params.signType, // 微信签名方式：
                      'paySign': params.paySign, // 微信签名
                  },
                    function(res){
                        WeixinJSBridge.log(res.err_msg);
                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                            $('.tc_navx').text('支付成功')
                            $('.tc_nav').fadeIn()
                            setTimeout(function(){
                                $('.tc_nav').fadeOut()
                                 location.href = '/mine/dingdan';
                            },1000)
                            
                        }else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                          $('.tc_navx').text('支付已取消')
                            $('.tc_nav').fadeIn()
                            setTimeout(function(){
                                $('.tc_nav').fadeOut()
                            },1000)
                        }else{
                          $('.tc_navx').text(res.err_desc)
                            $('.tc_nav').fadeIn()
                            setTimeout(function(){
                                $('.tc_nav').fadeOut()
                            },1000)
                        }
                    }
                );
            },
            add:function(){
                var successCallback =  (response) => {
                console.log('服务器请求成功了')
                if(response.status==200){
                  this.callpay(response.data);
                }else{
                    $('.tc_navx').text(response.msg)
                    $('.tc_nav').fadeIn()
                    setTimeout(function(){
                        $('.tc_nav').fadeOut()
                    },1000)
                }
              }
              var errorCallback =  (response) => {
                  console.log('服务器请求出错了')
              }
              // 音频 
              if(this.zpay[3]!=1){
                // 章节
                    if(this.zpay[1] != null && this.zpay[1] != NaN && this.zpay[1] != '' &&this.zpay[2] != null && this.zpay[2] != NaN && this.zpay[2] != ''){
                  this.$http.get(CURL+'/user/wxpay/pay?id='+this.zpay[1]
                  +'&openid='+this.openid
                  +'&type='+0
                  +'&money='+this.zpay[2],{
                        data:{}
                      }).then(successCallback,errorCallback);
                }else{ 
                // 专辑
                  this.$http.get(CURL+'/user/wxpay/pay?id='+this.$route.params.id
                  +'&type='+1
                  +'&openid='+this.openid
                  +'&money='+this.pay[2],{
                        data:{}
                      }).then(successCallback,errorCallback);
                }
              }else{
                    // 视频
                    // 章节
                  if(this.zpay[1] != null && this.zpay[1] != NaN && this.zpay[1] != '' &&this.zpay[2] != null && this.zpay[2] != NaN && this.zpay[2] != ''){
                  this.$http.get(CURL+'/user/wxpay/pay?id='+this.zpay[1]
                  +'&openid='+this.openid
                  +'&type='+2
                  +'&money='+this.zpay[2],{
                        data:{}
                      }).then(successCallback,errorCallback);
                }else{
                  // 专辑
                  this.$http.get(CURL+'/user/wxpay/pay?id='+this.zpay[0]
                  +'&type='+3
                  +'&openid='+this.openid
                  +'&money='+this.pay[2],{
                        data:{}
                      }).then(successCallback,errorCallback);
                }
              }
              

            },
          },
  mounted(){
  	 this.getAjax();
	
  }
  
};

</script>
<style lang="scss" scoped>
.tc_navx{
    background-color: #00a8d9;
    border-radius: 5px;
    padding: 10px 20px 10px 20px;
}
.tc_nav{
    display: none;
    position: fixed;
    margin-left: 20%;
    text-align: center;
    width: 60%;
/*  height: 30px;*/
    color: #ffffff;
    font-size: 15px;
    bottom: 70%;
}
/*cnt*/
.yxx_but{
	width: 94%;
	padding: 15px 0 15px 0;
	margin: 60px 3% 0 3%;
	border-radius: 5px;
	color: #FFFFFF;
	background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  font-size: 16px;
}
.yxx_b,.yxx_c,.yxx_d{
	border-bottom: #eee solid 2px;
	padding: 10px 0 10px 30px;
	font-size: 13px;
}
.yxx_a{
	text-align: center;
	font-size: 16px;
	border-bottom: #eee solid 2px;
	padding: 20px 0 20px 0;
}
.pay_xx{
	float: left;
	width: 100%;
}
/*head*/
header{
  height: .4rem;
  line-height: .4rem;
 	background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
 	float: left;
 	width: 100%;
 	h1{
   		margin-top: .2rem;
  	}
}
.set_1{
	text-align: center;
    float: left;
    width: 84%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height: 0;
}
.set_2{
	float: left;
	margin-left: 3%;
  margin-top: -7px;
	width: 5%;
	color: #FFFFFF;
}
	.pay{
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/discover/pay.vue